export enum CandidateLabel {
  Contacted = 'contacted',
  InterviewScheduled = 'interviewScheduled',
  InterviewCompleted = 'interviewCompleted',
  InterviewCancelled = 'interviewCancelled',
  LeftVoicemail = 'leftVoicemail',
  MoreInfoSent = 'moreInfoSent',
  NoAnswer = 'noAnswer',
  NotResponding = 'notResponding',
  NotInterested = 'notInterested',
  NotOpenToWork = 'notOpenToWork',
}
